import React, { useEffect, useMemo } from 'react';
import { useForm } from 'react-hook-form';
import VideoSelect from '../../Components/VideoSelect/VideoSelect';
import { useEditQuizMutation } from '../../features/quiz/quizApi';
import useGetUnUsedVideoId from '../../Hooks/useGetUnUsedVideoId';
import createOptionData, { correctIdString } from '../../utilities/CreateOptionData';
import CreateSingleOptions from '../AddQuiz/CreateSingleOptions';

const QuizEditModalContent = ({ data, setIsOpen }) => {
    const [editQuiz, { isLoading, isSuccess }] = useEditQuizMutation()
    const { register, handleSubmit, watch, formState: { errors } } = useForm();
    const { uniqIdVideos, isLoading: isVideoLoading } = useGetUnUsedVideoId({ extraId: undefined, shouldGiveAllId: true })

    const onSubmit = editedData => {
        const mainData = createOptionData(editedData, uniqIdVideos)
        mainData.id = data.id
        // AddQuiz(mainData)
        editQuiz(mainData)
    };
    useEffect(() => {
        if (isSuccess) {
            setIsOpen(false)
        }
    }, [isSuccess, setIsOpen])
    let content = null
    if (isVideoLoading) {
        content = <div>Loading...</div>
    } else {
        content = <form className='w-full' onSubmit={handleSubmit(onSubmit)}>
            <label>Question:</label>
            <input defaultValue={data.question} className='login-input mb-2' {...register("question", { required: true })} />

            <div className='grid grid-cols-2 gap-5 mt-5'>
                {
                    data?.options?.map((single,) => <CreateSingleOptions key={single.id} watch={watch} defaultIsCorrect={single.isCorrect} defaultOptionText={single.option} register={register} num={single.id} ></CreateSingleOptions>)
                }
                <div className='text-red-600'>
                    {errors[correctIdString(1)] ? 'Please select at least one correct ans!' : null}

                </div>
            </div>
            <div className="mt-5">
                <VideoSelect defaultValue={data.video_id} uniqIdVideos={uniqIdVideos} register={register}></VideoSelect>
            </div>
            <button disabled={isLoading} type='submit' className='mt-5 border-blue-300 border rounded-md px-2 py-2'>update Quiz</button>
        </form>
    }
    return (
        <div className='  '>
            {content}
        </div>
    );
};

export default QuizEditModalContent;